import { render, staticRenderFns } from "./StateTranslationNeeded.vue?vue&type=template&id=17aa8036&scoped=true&lang=pug&"
import script from "./StateTranslationNeeded.vue?vue&type=script&lang=coffee&"
export * from "./StateTranslationNeeded.vue?vue&type=script&lang=coffee&"
import style0 from "./StateTranslationNeeded.vue?vue&type=style&index=0&id=17aa8036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa8036",
  null
  
)

component.options.__file = "StateTranslationNeeded.vue"
export default component.exports